import { Box } from '@mui/material';
import { keyframes } from '@mui/system';

// Animation for top-left shape
const floatTopLeft = keyframes`
  0%, 100% {
    transform: translate(-60%, -30%) rotate(0deg);
  }
  33% {
    transform: translate(-55%, -35%) rotate(5deg);
  }
  66% {
    transform: translate(-65%, -25%) rotate(-5deg);
  }
`;

// Animation for top-right shape
const floatTopRight = keyframes`
  0%, 100% {
    transform: translate(30%, -30%) rotate(0deg);
  }
  33% {
    transform: translate(35%, -25%) rotate(-8deg);
  }
  66% {
    transform: translate(25%, -35%) rotate(8deg);
  }
`;

// Animation for bottom-right shape
const floatBottomRight = keyframes`
  0%, 100% {
    transform: translate(30%, 30%) rotate(0deg);
  }
  33% {
    transform: translate(25%, 35%) rotate(6deg);
  }
  66% {
    transform: translate(35%, 25%) rotate(-6deg);
  }
`;

const ShapeBackground = () => {
  return (
    <>
      {/* Solid background layer */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(141, 217, 237, 1.0)',
          zIndex: -2,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: -1,
          overflow: 'hidden',
          opacity: 1.0,
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            animation: `${floatTopLeft} 20s ease-in-out infinite`,
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 253 257" width="500" height="500">
            <path d="M31.476 31.4757A107.5775 107.5775 0 0 0 12.4377 57.222L57.233 12.4375a107.4157 107.4157 0 0 0-25.757 19.0382ZM77.2066 4.2999 4.3001 77.2064c-.86 2.9455-1.5802 5.9125-2.15 8.901L86.1183 2.1499c-2.9992.5913-5.9662 1.3115-8.9117 2.15ZM99.8352.2903.2902 99.8351C.1183 102.125 0 104.501 0 106.833L106.833 0c-2.332 0-4.708.1182-6.9978.2903ZM118.185.5269.5266 118.186c.1935 1.988.4623 3.966.7633 5.944L124.13 1.2901c-1.978-.301-3.956-.5697-5.945-.7632ZM133.999 3.3008 3.3002 133.999c.4515 1.752.9353 3.505 1.4728 5.235L139.234 4.7735c-1.731-.5375-3.483-1.0212-5.235-1.4727ZM148.005 7.8804 7.8792 148.007a92.3757 92.3757 0 0 0 2.0317 4.676L152.649 9.9121a95.3244 95.3244 0 0 0-4.644-2.0317ZM160.508 13.9746 13.9744 160.508c.8063 1.408 1.6448 2.816 2.5155 4.203L164.711 16.4794a92.5813 92.5813 0 0 0-4.203-2.5048ZM171.753 21.3066 21.2534 171.807c.946 1.275 1.9242 2.533 2.9347 3.773L175.526 24.2414c-1.236-1.0213-2.451-1.9888-3.773-2.9348ZM183.525 31.4768c-.559-.5698-1.151-1.075-1.72-1.634L29.8429 181.805c.5482.569 1.075 1.161 1.634 1.72.559.559 1.1502 1.075 1.72 1.634L185.159 33.1968c-.548-.5698-1.075-1.161-1.634-1.72ZM190.759 39.4736 39.4739 190.758a92.7623 92.7623 0 0 0 3.7732 2.935L193.747 43.1931a348.598 348.598 0 0 0-2.988-3.7195ZM198.52 50.2886 50.2886 198.52a109.859 109.859 0 0 0 4.2032 2.516L201.025 54.4918a92.5546 92.5546 0 0 0-2.505-4.2032ZM205.089 62.3501 62.3503 205.089c1.548.716 3.1067 1.393 4.6762 2.031L207.12 66.9941a82.8794 82.8794 0 0 0-2.031-4.644ZM210.226 75.7651 75.7652 210.226c1.7307.538 3.483 1.021 5.2352 1.473L211.699 81.0004c-.452-1.7523-.935-3.5045-1.473-5.2353ZM213.71 90.8696 90.8696 213.71c1.978.301 3.956.57 5.9448.763L214.473 96.8144c-.193-1.9888-.462-3.9668-.763-5.9448ZM108.167 215c2.332 0 4.665-.118 6.998-.29l99.545-99.545c.172-2.333.279-4.666.29-6.998L108.167 215ZM137.793 210.7l72.885-72.885c.86-2.945 1.581-5.912 2.15-8.901l-83.936 83.936c2.989-.591 5.956-1.312 8.901-2.15ZM183.524 183.524a107.4302 107.4302 0 0 0 19.038-25.8l-44.795 44.795a107.4002 107.4002 0 0 0 25.757-18.995ZM166 241c0 4.243-1.686 8.313-4.686 11.314-3.001 3-7.071 4.686-11.314 4.686s-8.313-1.686-11.314-4.686c-3-3.001-4.686-7.071-4.686-11.314s1.686-8.313 4.686-11.314c3.001-3 7.071-4.686 11.314-4.686s8.313 1.686 11.314 4.686c3 3.001 4.686 7.071 4.686 11.314Z"
              fill="rgba(51,112,255,1)" />
            <path d="M215 88c-20.976 0-38 17.024-38 38s17.024 38 38 38 38-17.024 38-38-17.024-38-38-38Zm0 72.2c-18.848 0-34.2-15.352-34.2-34.2 0-18.848 15.352-34.2 34.2-34.2 18.848 0 34.2 15.352 34.2 34.2 0 18.848-15.352 34.2-34.2 34.2Z"
              fill="rgba(51,112,255,1)" />
          </svg>
        </Box>
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            animation: `${floatTopRight} 25s ease-in-out infinite`,
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 132 186" width="264" height="372">
            <path d="M80 170c0 4.243-1.6857 8.313-4.6863 11.314A16.0021 16.0021 0 0 1 64 186a16.0021 16.0021 0 0 1-11.3137-4.686A16.0021 16.0021 0 0 1 48 170c0-4.243 1.6857-8.313 4.6863-11.314C55.6869 155.686 59.7565 154 64 154c4.2435 0 8.3131 1.686 11.3137 4.686A16.0021 16.0021 0 0 1 80 170ZM66 0C29.568 0 0 29.568 0 66s29.568 66 66 66 66-29.568 66-66S102.432 0 66 0Zm0 125.4C33.264 125.4 6.6 98.736 6.6 66S33.264 6.6 66 6.6s59.4 26.664 59.4 59.4-26.664 59.4-59.4 59.4Z"
              fill="rgba(51,112,255,1)" />
          </svg>
        </Box>
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            animation: `${floatBottomRight} 22s ease-in-out infinite`,
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 273 313" width="273" height="313">
            <path d="M89.4759 31.4757A107.5771 107.5771 0 0 0 70.4377 57.222l44.7953-44.7845a107.4163 107.4163 0 0 0-25.7571 19.0382ZM135.206 4.2999 62.3 77.2064c-.86 2.9455-1.5803 5.9125-2.15 8.901l83.968-83.9575c-2.999.5913-5.966 1.3115-8.912 2.15ZM157.835.2903l-99.5447 99.545C58.1183 102.125 58 104.501 58 106.834L164.834 0c-2.333 0-4.709.1182-6.999.2903ZM176.185.5269 58.5267 118.186c.1935 1.988.4623 3.966.7633 5.944L182.13 1.2901c-1.978-.301-3.956-.5697-5.945-.7632ZM191.999 3.3003 61.3002 133.999c.4515 1.752.9353 3.504 1.4728 5.235L197.234 4.773c-1.731-.5375-3.483-1.0212-5.235-1.4727ZM206.006 7.8799 65.8797 148.006a92.038 92.038 0 0 0 2.0317 4.676L210.65 9.9116a96.202 96.202 0 0 0-4.644-2.0317ZM218.508 13.9751 71.975 160.508c.8063 1.409 1.6448 2.817 2.5155 4.204L222.711 16.4798a92.6715 92.6715 0 0 0-4.203-2.5047ZM229.753 21.3066 79.2528 171.807c.946 1.275 1.9242 2.533 2.9347 3.773L233.526 24.2414c-1.236-1.0213-2.451-1.9888-3.773-2.9348ZM241.524 31.4758c-.559-.5698-1.15-1.075-1.72-1.634L87.842 181.804c.5483.57 1.075 1.161 1.634 1.72.559.559 1.1503 1.075 1.72 1.634L243.158 33.1958c-.548-.5698-1.075-1.161-1.634-1.72ZM248.759 39.4741 97.474 190.759a93.7975 93.7975 0 0 0 3.773 2.935l150.5-150.5004a348.598 348.598 0 0 0-2.988-3.7195ZM256.52 50.2886 108.289 198.52c1.39.875 2.791 1.713 4.203 2.516L259.025 54.4918a91.642 91.642 0 0 0-2.505-4.2032ZM263.089 62.3501 120.35 205.089c1.548.716 3.107 1.394 4.676 2.031L265.12 66.9941a83.6204 83.6204 0 0 0-2.031-4.644ZM268.227 75.7661 133.766 210.227c1.731.538 3.483 1.021 5.235 1.473L269.7 81.0014c-.452-1.7523-.936-3.5045-1.473-5.2353ZM271.71 90.8696 148.87 213.71c1.978.301 3.956.57 5.945.763L272.473 96.8144c-.193-1.9888-.462-3.9668-.763-5.9448ZM166.166 215c2.333 0 4.666-.118 6.999-.29l99.545-99.545c.172-2.333.279-4.666.29-6.998L166.166 215ZM195.794 210.7l72.885-72.885c.86-2.945 1.58-5.912 2.15-8.901l-83.936 83.936c2.988-.591 5.955-1.311 8.901-2.15ZM241.524 183.524a107.4035 107.4035 0 0 0 19.038-25.8l-44.795 44.795a107.4002 107.4002 0 0 0 25.757-18.995Z"
              fill="rgba(51,112,255,1)" />
            <path d="M76 135.5c0 5.967-2.3705 11.69-6.5901 15.91A22.5023 22.5023 0 0 1 53.5 158a22.5023 22.5023 0 0 1-15.9099-6.59A22.5015 22.5015 0 0 1 31 135.5c0-5.967 2.3705-11.69 6.5901-15.91A22.5023 22.5023 0 0 1 53.5 113a22.5023 22.5023 0 0 1 15.9099 6.59A22.5015 22.5015 0 0 1 76 135.5ZM71 171c-39.192 0-71 31.808-71 71s31.808 71 71 71 71-31.808 71-71-31.808-71-71-71Zm0 134.9c-35.216 0-63.9-28.684-63.9-63.9 0-35.216 28.684-63.9 63.9-63.9 35.216 0 63.9 28.684 63.9 63.9 0 35.216-28.684 63.9-63.9 63.9Z"
              fill="rgba(51,112,255,1)" />
          </svg>
        </Box>
      </Box>
    </>
  );
};

export default ShapeBackground;
